<template>
  <h1>Invalid for Booking</h1>
</template>
